// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qNnzsl{margin-top:30px}.eBoyFc,.uvHpRb{display:inline;padding:0}.uvHpRb ~ .uvHpRb::before{content:', ';opacity:0.6}.vdzzg7{float:left;width:20px;padding:1px 0}.HtqHQv{text-transform:capitalize;opacity:0.6}.HtqHQv:hover{text-decoration:none;opacity:1}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keywords": `qNnzsl`,
	"keywordsList": `eBoyFc`,
	"keywordsListItem": `uvHpRb`,
	"keywordsIcon": `vdzzg7`,
	"keywordsKeyword": `HtqHQv`
};
export default ___CSS_LOADER_EXPORT___;
